import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { CoreModule } from 'src/app/core/core.module';
import { ResourceCenterPageComponent } from './pages/resource-center-page/resource-center-page.component';


@NgModule({
  declarations: [
    ResourceCenterPageComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    CoreModule,
  ]
})
export class ResourceCenterModule { }
